type PhotoCollection = {
  key: string;
  label: string;
};

export const photoCollections: PhotoCollection[] = [
  { key: "dallas", label: "Dallas" },
  { key: "germany", label: "Germany" },
  { key: "nyc", label: "New York City" },
  { key: "thailand", label: "Thailand" },
];